import {z} from 'zod';
import {ApplicationTypeDto} from '../../../api';
import {baseApplicationSchema} from '../model';

export const baseProjektWeltApplicationSchema = z.object({
    applicationType: z.literal(ApplicationTypeDto.PROJEKT_WELT_MAIN).or(z.literal(ApplicationTypeDto.PROJEKT_WELT_ADDITIONAL)),
})
    .merge(baseApplicationSchema);

